import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility para componer clases Tailwind con deduplicación inteligente.
 * Requerido por shadcn/ui — todos sus componentes lo importan.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
